import React, { useEffect, useState } from "react";

import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import { getAuthHeaders, getStoredOrganizationId } from "./organizationStorage";
import { OrdersTable, OrdersTabs } from "./OrdersTable";

import "./css/today.css"; // Reuse the same CSS file

const History = ({ user_id }) => {
  const [orders, setOrders] = useState([]);
  const [pickupOrders, setPickupOrders] = useState([]);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Default to today's date
  });
  const [activeTab, setActiveTab] = useState("restaurantOrders");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const organizationId = getStoredOrganizationId();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        setError(null);
        if (!organizationId) {
          throw new Error("Organization not found. Please sign in again.");
        }

        const response = await axiosOrganizationInstance.get(
          `/organization/${organizationId}/orders`,
          {
            headers: getAuthHeaders(),
            params: { selectedDate },
          }
        );
        if (response.data.status === "success") {
          setOrders(response.data.data.orders);
          setPickupOrders(response.data.data.pickup_orders);
        } else {
          throw new Error("Failed to fetch orders and pickup orders");
        }
      } catch (err) {
        console.error(err);
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    
  
    fetchOrders();
  }, [organizationId, selectedDate]);
  
  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="today-container">
      <div className="today-content">
        <OrdersTabs activeTab={activeTab} onChange={setActiveTab}>
          <div className="date-selector">
            <input
              className="date-input"
              type="date"
              id="date"
              aria-label="Select date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </div>
        </OrdersTabs>

        {activeTab === "restaurantOrders" && (
          <div className="today-table-container">
            {(orders || []).length === 0 ? (
              <p className="nodata">No restaurant orders available for the selected date.</p>
            ) : (
              <OrdersTable rows={orders} idKey="orderId" />
            )}
          </div>
        )}

        {activeTab === "pickupOrders" && (
          <div className="today-table-container">
            {(pickupOrders || []).length === 0 ? (
              <p className="nodata">No pickup orders available for the selected date.</p>
            ) : (
              <OrdersTable rows={pickupOrders} idKey="pickupId" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default History;
